import { action } from 'satcheljs';

export interface LOAD_OWA_THEMEActionMessage {
    themeId: string;
    isDarkTheme: boolean | undefined;
    themesAllowed: boolean | undefined;
}
const defaultExport: (
    themeId: string,
    isDarkTheme?: boolean,
    themesAllowed?: boolean
) => LOAD_OWA_THEMEActionMessage = action(
    'LOAD_OWA_THEME',
    (
        themeId: string,
        isDarkTheme?: boolean,
        themesAllowed?: boolean
    ): LOAD_OWA_THEMEActionMessage => ({
        themeId,
        isDarkTheme,
        themesAllowed,
    })
);
export default defaultExport;
